const services = [
  {
    titleKey: "service_monitoring_title",
    descriptionKey: "service_monitoring_description",
    image: "/assets/service-monitoring.jpg",
    width: 800,
    height: 450,
    altKey: "service_monitoring_alt",
    icon: "monitoring",
  },
  {
    titleKey: "service_consulting_title",
    descriptionKey: "service_consulting_description",
    image: "/assets/service-consulting.jpg",
    width: 800,
    height: 450,
    altKey: "service_consulting_alt",
    icon: "consulting",
  },
  {
    titleKey: "service_vpn_title",
    descriptionKey: "service_vpn_description",
    image: "/assets/service-vpn.jpg",
    width: 800,
    height: 450,
    altKey: "service_vpn_alt",
    icon: "vpn",
  },
  {
    titleKey: "service_mikrotik_title",
    descriptionKey: "service_mikrotik_description",
    image: "/assets/service-mikrotik.jpg",
    width: 800,
    height: 450,
    altKey: "service_mikrotik_alt",
    icon: "routing",
  },
  {
    titleKey: "service_olt_title",
    descriptionKey: "service_olt_description",
    image: "/assets/service-olt.jpg",
    width: 800,
    height: 450,
    altKey: "service_olt_alt",
    icon: "olt",
  },
  {
    titleKey: "service_incidents_title",
    descriptionKey: "service_incidents_description",
    image: "/assets/service-incidents.jpg",
    width: 800,
    height: 450,
    altKey: "service_incidents_alt",
    icon: "incidents",
  }
]

export default services;
